export default "__VITE_ASSET__BqTIyVd3__"